// Module
var code = "<a class=\"modal-close icon-cancel\" title=Close ng-click=$dismiss()></a> ";
// Exports
module.exports = code;